// extracted by mini-css-extract-plugin
export default {"layout":"xEGx3","sidebar":"MRLrZ","main":"at8ty","container":"MYDPy","sidebar-wrapper":"bAN2c","drawer":"tC_4K"};